<template>
  <div id="app">
    <!-- <div :data-array='bannerTop' id="bannerId">{{bannerTop}}</div> -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      bannerTop:[]
    }
  },
  created() {
    var that = this
  },
  watch: {
    '$route': function(to, from){
      console.log('当前地址=======' + window.location.href)
      console.log('当前路由=======' + this.$route.path)
      switch(this.$route.path) {
        case '/':
          this.GLOBAL.nownav = 0
          break;
        case '/gjwm':
          this.GLOBAL.nownav = 1
          break;
        case '/cybj':
          this.GLOBAL.nownav = 2
          break;
        case '/jscx':
          this.GLOBAL.nownav = 3
          break;
        case '/xwzx':
           this.GLOBAL.nownav = 4
           break;
        case '/rcyj':
          this.GLOBAL.nownav = 5
          break;
        case '/lxwm':
          this.GLOBAL.nownav = 6
          break;
      }

    }
  },
  mounted() {

  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue